function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#798c9c",
  d: "M13 8l-3-3-3 3h6zm-.1 4L10 14.9 7.1 12h5.8z",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    className: "p_v3ASA",
    viewBox: "0 0 20 20",
    focusable: "false",
    "aria-hidden": "true"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/select_sort.9ac782f5.svg";
export { SvgComponent as ReactComponent };